import NiceModal from '@ebay/nice-modal-react';
import { useUserEventLogger } from '@repo/tracking-service';
import { List } from '@repo/ui';
import { useAuthContext } from '@repo/user-session';
import { useRouter } from 'next/router';

import { LogoutDialog } from '@/components/my/page/logout/LogoutDialog';
import { usePaymentCard } from '@/lib/hooks/use-payment-card';
import { SnsType } from '@/lib/types/auth';

export const LogoutButton = ({ loginType, email }: { email: string; loginType: SnsType }) => {
  const { setCardData } = usePaymentCard();
  const { setStatusSignOut } = useAuthContext();
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const handleLogout = () => {
    setCardData(null);
    sendClickEvent('my-info_modal_logout-confirm');
    setStatusSignOut(true);
    router.push('/');
  };

  const handleLogoutListClick = async () => {
    sendClickEvent('my-info_body_logout');

    const isConfirmed: boolean = await NiceModal.show(LogoutDialog, { email, loginType });
    if (!isConfirmed) return;

    handleLogout();
  };

  return <List title={'로그아웃'} primaryAction onClick={handleLogoutListClick} />;
};
